const isLocal = typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
const API_URL = isLocal ? "http://localhost:1337/api" : null;

export async function getArticles() {
    if (!API_URL) return [];
    try {
      const res = await fetch(`${API_URL}/articles?populate=*`);
      const json = await res.json();
      return json.data || [];
    } catch (e) {
      return [];
    }
}

export async function getProjects() {
    if (!API_URL) return [];
    try {
      const res = await fetch(`${API_URL}/projects?populate=*`);
      const json = await res.json();
      return json.data || [];
    } catch (e) {
      return [];
    }
}

export async function getProject(id) {
    if (!id || !API_URL) return null;
    try {
      // 1. Try direct fetch by documentId
      const res = await fetch(`${API_URL}/projects/${id}?populate=*`);
      if (res.ok) {
        const json = await res.json();
        if (json && json.data) return json.data;
      }
    } catch (e) {
      console.warn("Direct documentId fetch failed, searching project list:", e);
    }

    try {
      // 2. Fetch all projects and match by id, documentId, title, or index
      const allRes = await fetch(`${API_URL}/projects?populate=*`);
      if (allRes.ok) {
        const allJson = await allRes.json();
        if (allJson && allJson.data && Array.isArray(allJson.data)) {
          const match = allJson.data.find((p, idx) => 
            p.documentId === id ||
            String(p.id) === String(id) || 
            String(idx + 1) === String(id) ||
            (p.title && p.title.toLowerCase().includes(String(id).toLowerCase()))
          );
          if (match) return match;
        }
      }
    } catch (e) {
      console.warn("Project search failed:", e);
    }
    return null;
}

export async function getSkills() {
    if (!API_URL) return [];
    try {
      const res = await fetch(`${API_URL}/skills?populate=*&sort=order:asc`);
      const json = await res.json();
      return json.data || [];
    } catch (e) {
      return [];
    }
}